var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"splash"}},[_c('Header',[_c('div',{staticClass:"big-text"},[_vm._v("404: Page not found :/")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }